import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  packageSetsDescription: {
    defaultMessage: 'Create multi-package sets to use for multi-package shipments at package type selection.',
    id: '3ijTCU',
    description: 'Description of the package sets table.',
  },
  addPackageSetButton: {
    defaultMessage: 'Add Multi-Package Set',
    id: '9+4hEP',
    description: 'Button to add a package set.',
  },
  emptyPackageSetsMessage: {
    defaultMessage: 'No multi-package sets available.',
    id: '8uhzU/',
    description: 'Message to display when there are no package sets available.',
  },
  actionsColumnHeader: {
    defaultMessage: 'Actions',
    id: 'xvIRXF',
    description: 'Header for the actions column.',
  },
  nameColumnHeader: {
    defaultMessage: 'Name',
    id: 'VU9dO+',
    description: 'Header for the name column.',
  },
  widthColumnHeader: {
    defaultMessage: 'Width ({unit})',
    id: 'K5YDVm',
    description: 'Header for the width column.',
  },
  lengthColumnHeader: {
    defaultMessage: 'Length ({unit})',
    id: '+iq+hY',
    description: 'Header for the length column.',
  },
  heightColumnHeader: {
    defaultMessage: 'Height ({unit})',
    id: '6WkSI0',
    description: 'Header for the height column.',
  },
  weightColumnHeader: {
    defaultMessage: 'Weight',
    id: 'D/pHgc',
    description: 'Header for the weight column.',
  },
  insuranceColumnHeader: {
    defaultMessage: 'Insurance',
    id: 'xzXiVM',
    description: 'Header for the insurance column.',
  },
  altImageText: {
    defaultMessage: 'Empty Box',
    id: 'uj1g6g',
    description: 'Alt text for the empty box image.',
  },
  emptyBoxMessage: {
    defaultMessage: 'You do not have any multi-package sets',
    id: '5LJ5mF',
    description: 'Message to display when there are no package sets available.',
  },
  emptyPackageSetsInstructions: {
    defaultMessage: 'Select the "Add Multi-Package Set" button to get started.',
    id: 'My9Zcc',
    description: 'Instructions to add a package set.',
  },
  cm: {
    defaultMessage: 'cm',
    id: 'KMChuM',
    description: 'Abbreviation for centimeters in the package sets table column headers.',
  },
  in: {
    defaultMessage: 'in',
    id: 'djysED',
    description: 'Abbreviation for inches in the package sets table column headers.',
  },
  deletePackageSet: {
    defaultMessage: 'Delete',
    id: 'CGqJKF',
    description: 'Button to delete a package set.',
  },
});
